import { useState } from "react";
import { Pencil, Check, X } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { CONTEXTES_AUDIT, labelContexte } from "@/lib/checklist";
import { updateContexte } from "@/lib/dossiers";

export default function ContexteEditor({ dossierId, contexte, contexteAutre, onChange }) {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(contexte || "");
    const [autre, setAutre] = useState(contexteAutre || "");
    const [busy, setBusy] = useState(false);

    async function save() {
        if (!value) return toast.error("Choisissez un contexte");
        if (value === "autre" && !autre.trim()) return toast.error("Précisez le contexte");
        setBusy(true);
        try {
            const r = await updateContexte(dossierId, value, value === "autre" ? autre.trim() : null);
            onChange(r.contexte_audit, r.contexte_autre);
            setEditing(false);
            toast.success("Contexte de la mission mis à jour", { description: labelContexte(r.contexte_audit) });
        } catch (e) {
            toast.error("Mise à jour impossible", { description: e.message });
        } finally {
            setBusy(false);
        }
    }

    if (!editing) {
        return (
            <p data-testid="checklist-contexte" className="text-xs text-muted-foreground flex items-center gap-1.5">
                Contexte : {labelContexte(contexte)}{contexteAutre ? ` — ${contexteAutre}` : ""}
                <button type="button" data-testid="contexte-edit-button" onClick={() => { setValue(contexte || ""); setAutre(contexteAutre || ""); setEditing(true); }} title="Modifier le contexte" className="text-primary hover:underline inline-flex items-center gap-1">
                    <Pencil className="h-3 w-3" /> modifier
                </button>
            </p>
        );
    }
    return (
        <div data-testid="contexte-editor" className="flex flex-wrap items-center gap-2">
            <Select value={value} onValueChange={setValue}>
                <SelectTrigger data-testid="contexte-edit-select" className="h-8 w-72 bg-card text-xs"><SelectValue placeholder="Contexte…" /></SelectTrigger>
                <SelectContent>{CONTEXTES_AUDIT.map((c) => <SelectItem key={c.value} value={c.value} data-testid={`contexte-edit-${c.value}`}>{c.label}</SelectItem>)}</SelectContent>
            </Select>
            {value === "autre" && <Input data-testid="contexte-edit-autre" value={autre} onChange={(e) => setAutre(e.target.value)} placeholder="Précisez…" className="h-8 w-64 bg-card text-xs" />}
            <button type="button" data-testid="contexte-edit-save" onClick={save} disabled={busy} className="h-8 w-8 rounded-full flex items-center justify-center text-emerald-700 hover:bg-emerald-50"><Check className="h-4 w-4" /></button>
            <button type="button" data-testid="contexte-edit-cancel" onClick={() => setEditing(false)} className="h-8 w-8 rounded-full flex items-center justify-center text-muted-foreground hover:bg-accent"><X className="h-4 w-4" /></button>
        </div>
    );
}
